import {LabAutomationFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isConnectFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';
import {NavPreferences, Section, SECTIONS} from 'constants/NavConstants';
import {INSIGHTS_PRODUCT} from 'insights/NamingConstants';
import preferences from 'Preferences';
import {getLegacyRequestObjectName} from 'requests/RequestConstants';
import * as logging from 'util/Logging';
import {getWorkflowDisplayString} from 'workflows/util/WorkflowUtil';

export function sectionToReadable(section: Section): string | null {
  switch (section) {
    case SECTIONS.ANALYTICS:
      return INSIGHTS_PRODUCT;
    case SECTIONS.CONNECTIONS:
      return 'Connections';
    case SECTIONS.HOME:
      return 'Home';
    case SECTIONS.JELLYFISH:
      return 'Jellyfish (fake item type)';
    case SECTIONS.PROCESSES:
      return 'Workflows';
    case SECTIONS.PROJECTS:
    case SECTIONS.PROJECT_ITEMS:
      return 'Projects';
    case SECTIONS.REGISTRIES:
      return 'Registries';
    case SECTIONS.STORAGE:
      return 'Inventory';
    case SECTIONS.REQUESTS:
      return getLegacyRequestObjectName({plural: true});
    case SECTIONS.REQUESTS_V2_SUBMISSIONS:
    case SECTIONS.REQUESTS_V2_DEFINITIONS:
      return 'Requests';
    case SECTIONS.TFI: {
      return BenchlingConfig.ENABLE_BENCHLING_APPS ||
        isConnectFeatureEnabled({feature: LabAutomationFeature.LAB_AUTOMATION_DISCOVER})
        ? 'Connections'
        : 'External data';
    }
    case SECTIONS.BENCHLING_APPS:
      return 'Connections';
    case SECTIONS.SEARCH:
      return 'Search';
    case SECTIONS.WORKFLOWS:
      return getWorkflowDisplayString('Legacy Workflows', 'Workflows');
    case SECTIONS.DEVELOPER:
      return 'Developer tools';
    case SECTIONS.ONBOARDING_CHECKLISTS:
      return 'Explore Benchling';
    case SECTIONS.STUDIES:
      return 'Studies';
    case SECTIONS.TEMPLATE_COLLECTIONS:
      return 'Library';
    case SECTIONS.AI:
      return 'AI';
    case SECTIONS.MODEL_HUB:
      return 'Model Hub';
    default:
      logging.warn(`Unexpected section: ${section}`);
      break;
  }
  return null;
}

export function isCompactDisplay(): boolean {
  return preferences.get(NavPreferences.SIDEPANEL_IS_DISPLAY_COMPACT) || false;
}
